import React from 'react';

export const SubstepHeader = ({ substeps, current }) => (
  <div className="substep-header">
    {substeps.map((label, index) => (
      <React.Fragment key={index}>
        <span className={`substep-label ${index === current ? 'active' : ''}`}>
          {label}
        </span>
        {index < substeps.length - 1 && <span className="substep-separator">•</span>}
      </React.Fragment>
    ))}
  </div>
);

export default SubstepHeader;